let thisVuetify;
const state = {
  icons: {},
  themes: {},
  appliedThemeName: 'light',

  //configuration (not reactive property)
  appliedTheme: { colors: {}, components: {} }, // currently applied theme, shadow of vuetify color scheme plus component scheme
};

function setVuetifyTheming(themes) {
  let r = document.querySelector(':root');
  let newColors = themes.newColors
    ? themes.newColors
    : {
        warning: 'orange',
        warningText: 'white',
        warningDark: 'orange',
        warningDarkTest: '#f0f0f0',
      };
  r.style.setProperty('--i-warning', newColors.warning);
  r.style.setProperty('--i-warning-text', newColors.warningText);
  r.style.setProperty('--i-warning-dark', newColors.warningDark);
  r.style.setProperty('--i-warning-dark-text', newColors.warningDarkTest);

  r.style.setProperty('--C202020', '#202020');
  r.style.setProperty('--Cd0d0d0', '#d0d0d0');

  if (thisVuetify) {
    // Configure vuetify light theme with colors configured in ui-config/themes.light
    let light = themes.light.colors;
    thisVuetify.theme.themes.light.selectedListItemColor = '#e8eaec';
    thisVuetify.theme.themes.light.emphasizedListItemColor = '#abdefe';

    thisVuetify.theme.themes.light.error = '#d3000c';
    thisVuetify.theme.themes.light.info = '#97ccf0';
    thisVuetify.theme.themes.light.success = '#498b18';
    thisVuetify.theme.themes.light.warning = '#FF5E13';
    thisVuetify.theme.themes.light.background = '#fff';

    Object.keys(light).forEach((cf) => {
      // console.debug("set light theme",cf,light[cf])
      thisVuetify.theme.themes.light[cf] = light[cf];
    });

    // Configure vuetify dark theme with colors configured in ui-config/themes.dark
    let dark = themes.dark.colors;
    thisVuetify.theme.themes.dark.selectedListItemColor = '#606060';
    thisVuetify.theme.themes.dark.emphasizedListItemColor = '#0a3d57';

    thisVuetify.theme.themes.dark.error = '#ff9800';
    thisVuetify.theme.themes.dark.info = '#0288D1';
    thisVuetify.theme.themes.dark.success = '#498b18';
    thisVuetify.theme.themes.dark.warning = '#FF5E13';
    thisVuetify.theme.themes.dark.background = '#101010';

    // set dark mode colors for error, info, success, warning and background as common colors -> can be overwritten by setting those colors in ui-config

    Object.keys(dark).forEach((cf) => {
      thisVuetify.theme.themes.dark[cf] = dark[cf];
    });
  }
}

const getters = {};

const mutations = {
  provideVuetify(state, vuetify) {
    thisVuetify = vuetify;
  },
  /**
   *
   * @param {*} state
   * @param {*} {themes configured in ui-config consisting of dark and light scheme, and applicableTheme (dark or light)}
   */
  setThemes(state, { themes, applicableTheme }) {
    if (themes) {
      state.themes = Object.freeze(themes);
      state.appliedTheme = themes[applicableTheme];
      state.appliedThemeName = applicableTheme;
      setVuetifyTheming(themes);

      state.icons = themes.icons;
    }
  },
  switchTheme(state) {
    let appliedThemeName = state.appliedThemeName === 'dark' ? 'light' : 'dark';
    localStorage.setItem('theme', appliedThemeName);
    state.appliedThemeName = appliedThemeName;
    state.appliedTheme = state.themes[appliedThemeName];
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
